import { render, staticRenderFns } from "./RowAnswer.vue?vue&type=template&id=a8f16b74&scoped=true"
import script from "./RowAnswer.vue?vue&type=script&lang=js"
export * from "./RowAnswer.vue?vue&type=script&lang=js"
import style0 from "./RowAnswer.vue?vue&type=style&index=0&id=a8f16b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f16b74",
  null
  
)

export default component.exports